import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: "ready", // ready, loading, error, success,
    user: null, // name
    autoModal: false,
    location: "제주",
    monitoringId: null
  },
  mutations: {
    authRequest(state) {
      state.status = "loading";
    },
    authSuccess(state, payload) {
      state.status = "success";
      state.user = payload.user.name;
    },
    authError(state) {
      state.status = "error";
      state.user = null;
    },
    logout(state) {
      state.status = "ready";
      state.user = null;
    },
    autoModalCtrl(state) {
      state.autoModal = !state.autoModal;
    },
    locationCtrl(state, payload) {
      state.location = payload.location;
    },
    monitorCtrl(state, payload) {
      state.monitoringId = payload.id;
    }

  },
  actions: {
    login({ commit }, { accessToken, user }) {
      commit("authRequest");
      localStorage.setItem("accessToken", accessToken);
      commit("authSuccess", { user: user });
    },
    logout({ commit }) {
      localStorage.removeItem("accessToken");
      commit("logout");
    },
    autoModalCtrl({ commit }) {
      commit("autoModalCtrl");
    },
    locationCtrl({ commit }, { location }) {
      commit("locationCtrl", { location });
    },
    monitorCtrl({ commit }, { id }) {
      commit("monitorCtrl", { id });
    }
  },
  getters: {
    userAuth: state => {
      return state.user;
    },
    autoModalState: state => {
      return state.autoModal;
    },
    locationState: state => {
      return state.location;
    },
    monitoringIdState: state => {
      return state.monitoringId;
    }
  }
});
